import { fetch } from '../fetchWrapper/fetch';
import { EXTENSIONS_API_URL } from '../../constants';
import { ICreateExtensionRequest, IExtension } from './types';

export const createExtension = async (
  brandId: string,
  payload: ICreateExtensionRequest,
): Promise<IExtension> => {
  try {
    const res = await fetch(EXTENSIONS_API_URL, {
      method: 'POST',
      headers: {
        'content-type': 'application/json',
        'brand-id': brandId,
      },
      body: JSON.stringify(payload),
    });
    if (res.status !== 200 && res.status !== 201) {
      const errorBody = await res.json().catch(() => ({}));
      throw new Error(errorBody.message || `Request failed with status ${res.status}`);
    }
    const json: { data: IExtension[] } = await res.json();
    if (!json.data?.[0]) {
      throw new Error('Invalid response: no extension data returned');
    }
    return json.data[0];
  } catch (e) {
    if (e instanceof Error) throw e;
    throw new Error('Could not create extension');
  }
};
